import React, { Component } from "react";
import { PureComponent } from "react";
import { getPlayerStatus, getTeamDeadlineObj } from "../../common";
import config from "../../common/config";
import PrintStats from "./printStats";
import moment from "moment";
import { Consume } from "../../Context/Consumer";
import { FixturesContext, LiveScoringContext } from "../../Context";

class PlayerStatsByMatchDay extends PureComponent {
  constructor(props) {
    super(props);
    // this.autoComplete.bind(this)
  }

  renderRow = (statsObj, pointsObj) => {
    let { trans, getTrans } = this.props;
    // config.popUpStat
    // Object.keys(statsObj).filter((keys) => {
    //   if (config.popUpStat[keys]) {
    //     console.log(config.popUpStat[keys]);
    //   }
    // });
    return Object.keys(config.popUpStat).map((keys, ind) => {
      if (statsObj[keys] > 0) {
        return (
          <div className="si-tbl__row" key={ind}>
            <div className="si-tbl__cell si-tbl__cell--evt">
              <span>{getTrans(trans, keys, keys)}</span>
            </div>
            <div className="si-tbl__cell si-tbl__cell--act">
              <span>{statsObj[keys]}</span>
            </div>
            <div
              className="si-tbl__cell si-tbl__cell--pts"
              style={{ direction: "ltr" }}
            >
              <span>{pointsObj[keys]}</span>
            </div>
          </div>
        );
      }
    });
  };

  render() {
    let self = this;
    const { renderRow } = self;
    let { trans, config, player, currMatchDay, playerDetailsObj, getTrans } =
      self.props;

    let statsObj = currMatchDay.GamedayStats;
    let pointsObj = currMatchDay.GamedayPoints;
    let matchStatus = currMatchDay.MatchStatus;
    // return (
    //     <PrintStats statsObj={ statsObj } pointsObj={ pointsObj } getTrans={ getTrans } trans={ trans } playerDetailsObj={ playerDetailsObj } pointsByMD={ true } />
    // )
    let { isPlayerPlaying, playerTeamPlayingStatus } =
      self.props.LiveScoringData?.scoring !== null &&
      getPlayerStatus(
        player,
        currMatchDay,
        self.props.LiveScoringData?.scoring
      );

    if (
      matchStatus == "0" ||
      (matchStatus == "1" &&
        playerTeamPlayingStatus === config.enumTeamPlayingStatus.isPlaying &&
        !isPlayerPlaying) ||
      (matchStatus == "2" &&
        ((player.IsPlayed === 0 &&
          currMatchDay.GamedayId ===
            self.props.FixturesData.currMatchDay.GamedayId) ||
          (Object.keys(currMatchDay.GamedayStats).length > 0
            ? +currMatchDay.GamedayStats.OnField === 0
            : true)))
    ) {
      //upcoming  si-upcoming
      let matchTime = "";
      let matchDate = currMatchDay.MatchDateTime;
      let displayDate = "";
      //if (currMatchDay.IsTbc == "1") {
      if (matchDate) {
        /*  matchDate = new Date(matchDate)
      let fullDate = moment(`${matchDate}`);
      let date = fullDate.locale('en').format('DD');
      let month = fullDate.locale(config.language).format('MMMM');
      let time = fullDate.locale("en").format('HH:mm'); */
        displayDate = getTeamDeadlineObj(
          trans,
          config.WebConfig.OffSet,
          matchDate
        ).displayDate;
        matchTime = getTeamDeadlineObj(
          trans,
          config.WebConfig.OffSet,
          matchDate
        ).matchTime;
        console.log(matchDate);
      }
      // displayDate = getTrans(trans, "TBC", "TBC");
      // matchTime = getTrans(trans, "TBC", "TBC");
      //}

      return currMatchDay.IsTbc == "1" ? (
        <div className="si-player__noData">
          <span>{getTrans(trans, "TBC", "TBC")}</span>
        </div>
      ) : (
        <div className="si-player__noData">
          <span>
            {matchStatus == "0"
              ? `${displayDate}, ${matchTime}`
              : getTrans(trans, "matchNotPlayed", "Did not play")}{" "}
            {/* {getTrans(trans, "CET", "CET")} */}
          </span>
        </div>
      );
    }

    return (
      <React.Fragment>
        {/* {!(+statsObj["oF"] > 0) && +matchStatus === 2 ? (
          <div className="si-match__details">
            <div className="si-training-details">
              <div className="si-training-type">
                <span>{getTrans(trans, "matchNotPlayed", "Did not play")}</span>
              </div>
            </div>{" "}
          </div>
        ) : // (+matchStatus === 0 && (playerDetailsObj.bio.MatchAtd && playerDetailsObj.bio.MatchAtd !== '')) ?
        +matchStatus === 0 && playerDetailsObj.bio.trained ? (
          <div className="si-match__details">
            <div className="si-training-details">
              <div className="si-trainy-icon">
                <i className="euro-training" />
              </div>
              <div className="si-training-type">
                <span>
                  {getTrans(trans, "trainingLabel", "Training update:")}
                </span>
                <span>{playerDetailsObj.bio.trained}</span>
              </div>
            </div>
          </div>
        ) : statsObj && Object.keys(statsObj).length > 0 ? (
          <PrintStats
            statsObj={statsObj}
            pointsObj={pointsObj}
            getTrans={getTrans}
            trans={trans}
            playerDetailsObj={playerDetailsObj}
            pointsByMD={true}
          />
        ) : (
          ""
        )} */}

        <div className="si-player__tbl">
          <div className="si-tbl">
            <div className="si-tbl__head">
              <div className="si-tbl__row">
                <div className="si-tbl__cell si-tbl__cell--evt">
                  <span>{getTrans(trans, "statistics", "Statistics")}</span>
                </div>
                <div className="si-tbl__cell si-tbl__cell--act">
                  <span>{getTrans(trans, "Value", "Value")}</span>
                </div>
                <div className="si-tbl__cell si-tbl__cell--pts">
                  <span>{getTrans(trans, "Points", "Points")}</span>
                </div>
              </div>
            </div>
            <div className="si-tbl__body">{renderRow(statsObj, pointsObj)}</div>
            <div className="si-tbl__foot">
              <div className="si-tbl__row">
                <div className="si-tbl__cell si-tbl__cell--evt">
                  <span>{getTrans(trans, "matchPoints", "Match Points")}</span>
                </div>
                <div className="si-tbl__cell si-tbl__cell--act">
                  <span />
                </div>
                <div
                  className="si-tbl__cell si-tbl__cell--pts"
                  style={{ direction: "ltr" }}
                >
                  <span>{pointsObj?.TotalPoints}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Consume(PlayerStatsByMatchDay, [
  LiveScoringContext,
  FixturesContext,
]);
